export default __webpack_public_path__ + "static/media/greece20-en.5a16e591.png";